import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconHelpQuestionmark = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--help-questionmark")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
          <path d="M12 1C5.928 1 1 5.928 1 12s4.928 11 11 11 11-4.928 11-11S18.072 1 12 1zm0 19.8c-4.851 0-8.8-3.949-8.8-8.8 0-4.851 3.949-8.8 8.8-8.8 4.851 0 8.8 3.949 8.8 8.8 0 4.851-3.949 8.8-8.8 8.8zm-1.1-4.4h2.2v2.2h-2.2v-2.2zm1.771-10.956a4.402 4.402 0 0 0-4.873 3.069.997.997 0 0 0 .957 1.287h.22c.451 0 .814-.319.968-.737a2.202 2.202 0 0 1 2.53-1.408c1.045.22 1.815 1.243 1.727 2.31-.11 1.474-1.782 1.793-2.695 3.168 0 .011-.011.011-.011.022-.011.022-.022.033-.033.055a3.665 3.665 0 0 0-.275.55c-.011.033-.033.055-.044.088-.011.022-.011.044-.022.077a4.09 4.09 0 0 0-.22 1.375h2.2c0-.462.121-.847.308-1.177.022-.033.033-.066.055-.099.088-.154.198-.297.308-.429.011-.011.022-.033.033-.044.11-.132.231-.253.363-.374 1.056-1.001 2.486-1.815 2.189-3.916-.264-1.914-1.771-3.531-3.685-3.817z" fill="currentColor"/>
      </g>
  </IconWrapper>
)
